import {Injectable} from '@angular/core';
import * as _ from 'lodash-es';
import {Observable, Subject} from 'rxjs';
import {filter, tap} from 'rxjs/operators';
import {TxHistoryRec} from '../../../../widgets/dex-tx-history-widget/tx-history-rec';
import {
    txHistoryRecFromTransactionApi
} from '../../../../widgets/dex-tx-history-widget/tx-storage/transaction-api.mapper';
import {TransactionApiModel} from '../../../../widgets/dex-tx-history-widget/tx-storage/transaction-api.model';
import type {WebSocketMessage} from '../../../streaming/streaming-interfaces';
import {SubscriptionSubjectType} from '../../../streaming/subscription-subject-type';
import {DexStreamingSubjectService} from './dex-subjects-injection';

enum DexStreamingTransactionsMsgType {
    TRANSACTIONS_SNAPSHOT = 'TRANSACTIONS_SNAPSHOT',
    TRANSACTIONS_UPDATE   = 'TRANSACTIONS_UPDATE'
}

interface DexStreamingTransactionsSnapshotMsg {
    messageType: DexStreamingTransactionsMsgType.TRANSACTIONS_SNAPSHOT;
    data: TransactionApiModel[];
}

interface DexStreamingTransactionsUpdateMsg {
    messageType: DexStreamingTransactionsMsgType.TRANSACTIONS_UPDATE;
    data: TransactionApiModel;
}

type SubjectMsg = DexStreamingTransactionsSnapshotMsg | DexStreamingTransactionsUpdateMsg;

@Injectable()
export class DexTransactionsSubjectService implements DexStreamingSubjectService<SubjectMsg> {

    public readonly type: SubscriptionSubjectType<SubjectMsg>;

    public readonly txUpdated$: Observable<TxHistoryRec>;

    private subscriptionSentSubject = new Subject<any>();
    private disconnectedSubject = new Subject<any>();

    private readonly txUpdatedSubject$ = new Subject<TxHistoryRec>();

    constructor() {
        this.type = this.createType();
        this.txUpdated$ = this.txUpdatedSubject$.asObservable();
    }

    private createType(): SubscriptionSubjectType<SubjectMsg> {
        return {
            name: 'DEX_TRANSACTIONS',
            operations: {
                SUBSCRIBE: 'SUBSCRIBE_TRANSACTIONS',
                UNSUBSCRIBE: 'UNSUBSCRIBE_TRANSACTIONS'
            },
            messagePipe: _.flow(
                filter((message: WebSocketMessage) => message.messageType in DexStreamingTransactionsMsgType),
                tap((message: SubjectMsg): void => this.readMessage(message))
            ),
            subscriptionSent$: this.subscriptionSentSubject,
            disconnected$: this.disconnectedSubject
        };
    }

    private readMessage(message: SubjectMsg): void {
        switch (message.messageType) {
            case DexStreamingTransactionsMsgType.TRANSACTIONS_SNAPSHOT: {
                message.data.forEach(item => {
                    const tx = txHistoryRecFromTransactionApi(item);

                    this.txUpdatedSubject$.next(tx);
                });
                break;
            }
            case DexStreamingTransactionsMsgType.TRANSACTIONS_UPDATE: {
                const tx = txHistoryRecFromTransactionApi(message.data);

                this.txUpdatedSubject$.next(tx);
            }
        }
    }

}
